import { timeSince } from '../utils/format'
import { useState, useEffect } from 'react'

interface TimeSinceProps {
  timestamp: number | Date
}

export default function TimeSince({ timestamp }: TimeSinceProps) {
  const [time, setTime] = useState(() => {
    const ts = timestamp instanceof Date ? timestamp.getTime() : timestamp
    return timeSince(ts)
  })

  useEffect(() => {
    const interval = setInterval(() => {
      const ts = timestamp instanceof Date ? timestamp.getTime() : timestamp
      setTime(timeSince(ts))
    }, 10000) // Update every 10 seconds

    return () => clearInterval(interval)
  }, [timestamp])

  return <>{time ? `${time} ago` : '-'}</>
}

